import { render, staticRenderFns } from "./ExportgroupDetail.vue?vue&type=template&id=4cf741f4"
import script from "./ExportgroupDetail.vue?vue&type=script&lang=js"
export * from "./ExportgroupDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports